import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home.vue'
import Chat from '../components/Chat.vue'
import TimeControl from '../components/TimeControl'
import Settings from '../components/Settings'
// import App from '../../src/App'
import Notifications from '../components/Notifications'
import FollowUpPanel from '../components/FollowUpPanel'
import ReminderPanel from '../components/ReminderPanel'

export const evbus = new Vue();
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    // {
    //   path: '/notifications',
    //   name: 'Notifications',
    //   component: Notifications,
    //   props: (route) => ({
    //     adm: route.adm
    //   })
    // },
    
      // { path: '/', redirect: { name: 'Chat' }},
      {
        path: '/',
          name: 'Home',
          component: Home,
          children: [
            {
              path: `chats`,
              name: 'Chat',
              component: Chat
            },
            {
              path: '/notifications',
              name: 'Notifications',
              component: Notifications
            },
            {
              path: '/time_control',
              name: 'TimeControl',
              component: TimeControl
            },
             {
              path: '/settings',
              name: 'Settings',
              component: Settings
            },
            {
              path: '/followup',
              name: 'FollowUpPanel',
              component: FollowUpPanel
            },
            {
              path: '/reminder',
              name: 'ReminderPanel',
              component: ReminderPanel
            }
          ]
       },
    
   
    // {
    //   path: '/time_control',
    //   name: 'TimeControl',
    //   component: TimeControl,
    //   props: (route) => ({
    //     currAdm: route.currAdm
    //   })
    // },
    // {
    //   path: '/settings',
    //   name: 'Settings',
    //   component: Settings,
    //   props: (route) => ({
    //     currAdm: route.currAdm
    //   })
    // },
    // {
    //   path: '/followup',
    //   name: 'FollowUpPanel',
    //   component: FollowUpPanel,
    //   props: (route) => ({
    //     currAdm: route.currAdm
    //   })
    // }


  ]
})

export default router

// {
//   path: '/login',
//   name: 'App',
//   component: App
// },